import { Box, Card, Stack, Typography } from '@mui/material';
import SimCardAlertOutlinedIcon from '@mui/icons-material/SimCardAlertOutlined';
import { contentWidths } from '@/constants/brandingThemes';
import backgroundImage from '@/images/auth-background-layout.png';

export const NotFound = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: '30px 10px',
          maxWidth: contentWidths.small,
          margin: '0 auto',
        }}>
        <Card>
          <Stack alignItems="center" direction="column" gap={2}>
            <SimCardAlertOutlinedIcon
              sx={{ fontSize: 100, color: 'rgba(0, 0, 0, 0.6)' }}
            />
            <Typography
              variant="h2"
              component="h1"
              textAlign="center"
              color="text.secondary"
              fontWeight="normal">
              Page Not Found
            </Typography>
            <Typography
              variant="h4"
              textAlign="center"
              fontWeight="bold"
              color="text.secondary">
              Error 404
            </Typography>
            <Typography
              textAlign="center"
              variant="h5"
              component="p"
              color="text.secondary"
              fontWeight="normal">
              We apologize for the inconvenience.
            </Typography>
          </Stack>
        </Card>
      </Box>
    </Box>
  );
};
